import classnames from "classnames";
import { noop } from "lodash";
import type { QuizAttemptOption } from "@/react/types/QuizAttempt";
import { Form } from "@circle-react-uikit/Form";
import { Typography } from "@circle-react-uikit/Typography";

interface OptionItemProps {
  option: QuizAttemptOption;
  questionType: "single_choice" | "multiple_choice";
}

export const OptionItem = ({ option, questionType }: OptionItemProps) => (
  <div className="mt-4 flex items-center">
    <Form.Item hideLabel hideDescription hideBorder className="!mr-1 !p-0">
      <Form.Checkbox
        checked={option.selected}
        disabled={option.selected}
        name={questionType}
        isRoundedFull={questionType === "single_choice"}
        className="!mt-0"
        inputClassName={classnames(
          "disabled:!bg-toggle-inactive disabled:!border-transparent focus:!outline-none",
          {
            "hover:!bg-primary focus:!bg-primary": !option.selected,
            "hover:!bg-v2-success focus:!bg-v2-success": option.selected,
          },
        )}
        onChange={noop}
      />
    </Form.Item>
    <div className="!grow !p-0">
      <Typography.BodyMd>{option.value}</Typography.BodyMd>
    </div>
  </div>
);
